const commonParam = {
  // 系统名称
  systemName: "evaluation",
  // 服务器路径
  // serverUrl: 'http://192.168.1.100:26000',
  serverUrl: 'https://api3.smesc.cn',
  // 图片地址接口地址
  showImgUrl: 'https://eps.smesc.cn/img',
  // showImgUrl: 'http://192.168.1.212/smesc',
  successCode: 200,
  tokenStorageName: "tokenInfo",
  tokenStorageTime: "tokenStorageTime",
  // token过期时间
  tokenOverTime: 2 * 60 * 60 * 992,
  // 刷新token过期时间
  refreshTokenOverTime: 3 * 24 * 60 * 60 * 992,
  // 刷新token请求超时时间
  refreshRequestOutTime: 6 * 1000,
  // 页眉名字
  headerName: "headerName",
  // 首页左上角名字
  tabName: '中国中小企业四川中小网',
  // 登录页面名字
  loginPlatformName: '中国中小企业四川网',
  // 公司名称
  systemCompany: '四川中小企业信息服务有限责任公司',
  // 公司联系电话
  systemTel: "028-962555",
  // 备案号
  systemRecord: '蜀ICP备11006773号-11',
  // 指导单位
  guidingUnit: '中华人民共和国工业和信息化部',
  // 主管单位
  competentUnit: '四川省经济和信息化厅',
  // 系统脚下名字
  footerText: '<i class="fa fa-fw fa-copyright"></i>2022 系统脚下名字 All Rights Reserved',
}

export default commonParam;